import { FormattedMessage } from 'react-intl';
import { NotificationOrigin } from '@synergy/models';
import { PaloNotificationDocument, PaloNotificationSettings } from '@synergy/components-palo';
import { ReactElement, useEffect } from 'react';

import {
    createNotification,
    deleteNotification,
    fetchNotifications,
} from '../../../common/actions/notifications-actions';
import { useSelector } from '../../../store/use-appstate-selector';
import { useThunkDispatch } from '../../../store/use-thunk-dispatch';

/** The documents a member receives, in the order of the template of 15.10.2026 (#2284). */
const DOCUMENTS: PaloNotificationDocument[] = [
    {
        origin: NotificationOrigin.PurchaseOrderShop,
        title: <FormattedMessage id="app.notifications.palo.member.shopOrder" />,
        hint: <FormattedMessage id="app.notifications.palo.member.shopOrder.hint" />,
        standard: <FormattedMessage id="app.notifications.palo.member.shopOrder.standard" />,
    },
    {
        origin: NotificationOrigin.PurchaseOrderManual,
        title: <FormattedMessage id="app.notifications.palo.member.poolOrder" />,
        hint: <FormattedMessage id="app.notifications.palo.member.poolOrder.hint" />,
        standard: <FormattedMessage id="app.notifications.palo.member.poolOrder.standard" />,
    },
    {
        origin: NotificationOrigin.Invoice,
        standard: <FormattedMessage id="app.notifications.palo.member.invoice.standard" />,
    },
    {
        origin: NotificationOrigin.Demand,
        hint: <FormattedMessage id="app.notifications.palo.member.demand.hint" />,
        standard: <FormattedMessage id="app.notifications.palo.member.demand.standard" />,
    },
    {
        origin: NotificationOrigin.Inquiry,
        hint: <FormattedMessage id="app.notifications.palo.member.inquiry.hint" />,
        standard: <FormattedMessage id="app.notifications.palo.member.inquiry.standard" />,
    },
    {
        origin: NotificationOrigin.Import,
        standard: <FormattedMessage id="app.notifications.palo.companyEmail" />,
        hidden: true,
    },
];

export const PaloNotifications = (): ReactElement => {
    const dispatch = useThunkDispatch();
    const settings = useSelector(state => state.notifications.notifications);

    useEffect(() => {
        dispatch(fetchNotifications());
    }, [dispatch]);

    return (
        <PaloNotificationSettings
            title={<FormattedMessage id="app.navigation.notifications" />}
            documents={DOCUMENTS}
            settings={settings}
            onAdd={(origin, email) =>
                dispatch(createNotification({ notificationOrigin: origin, recipientEmail: email }))
            }
            onRemove={id => dispatch(deleteNotification(id))}
        />
    );
};
